import { j as s } from "../../../_virtual/jsx-runtime.js";
import { COMMON_COLORS as e } from "../../../constants/colors.js";
import { cn as i } from "../../../lib/utils.js";
const d = ({
  width: o = "100%",
  color: r = e.greyLight,
  thickness: t = "1px",
  className: m
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: i("mx-auto", m),
    style: {
      width: o,
      borderBottom: `${t} solid ${r}`
    }
  }
);
export {
  d as default
};
